import type { SVGComponentProps } from 'BreetHelpers';

export const UploadIcon = ({ ...props }: SVGComponentProps) => (
	<svg
		width='41'
		height='40'
		viewBox='0 0 41 40'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<rect
			x='0.75'
			y='0.25'
			width='39.5'
			height='39.5'
			rx='7.75'
			fill='white'
		/>
		<rect
			x='0.75'
			y='0.25'
			width='39.5'
			height='39.5'
			rx='7.75'
			stroke='#EAECF0'
			strokeWidth='0.5'
		/>
		<path
			d='M17.1665 23.3333L20.4998 20M20.4998 20L23.8332 23.3333M20.4998 20V27.5M27.1665 23.9524C28.1844 23.1117 28.8332 21.8399 28.8332 20.4167C28.8332 17.8854 26.7811 15.8333 24.2498 15.8333C24.0677 15.8333 23.8974 15.7383 23.8049 15.5814C22.7182 13.7374 20.7119 12.5 18.4165 12.5C14.9647 12.5 12.1665 15.2982 12.1665 18.75C12.1665 20.4718 12.8627 22.0309 13.989 23.1613'
			stroke='#475467'
			strokeWidth='1.66667'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
